"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableFieldCells = void 0;
const text_cell_1 = require("./cells/text-cell");
const boolean_cell_1 = require("./cells/boolean-cell");
const file_cell_1 = require("./cells/file-cell");
const number_cell_1 = require("./cells/number-cell");
const date_cell_1 = require("./cells/date-cell");
const decimal_field2_cell_1 = require("./cells/decimal-field2-cell");
const date_time_cell_1 = require("./cells/date-time-cell");
const time_cell_1 = require("./cells/time-cell");
const select_cell_1 = require("./cells/select-cell");
const autocomplete_cell_1 = require("./cells/autocomplete-cell");
exports.TableFieldCells = {
    BooleanCell: boolean_cell_1.BooleanCell,
    TextCell: text_cell_1.TextCell,
    NumberCell: number_cell_1.NumberCell,
    DateCell: date_cell_1.DateCell,
    DateTimeCell: date_time_cell_1.DateTimeCell,
    DecimalField2Cell: decimal_field2_cell_1.DecimalField2Cell,
    TimeCell: time_cell_1.TimeCell,
    useSelectCellFactory: select_cell_1.useSelectCellFactory,
    useAutocompleteCellFactory: autocomplete_cell_1.useAutocompleteCellFactory,
    FileCell: file_cell_1.FileCell,
};
//# sourceMappingURL=table-field-cells.js.map